var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1000008671(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F6901F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10C14.6916 10 12 12.5994 12 15.7946C12 19.7598 17.3694 25.581 17.598 25.8269C17.8127 26.0579 18.1876 26.0575 18.402 25.8269C18.6306 25.581 24 19.7598 24 15.7946C23.9999 12.5994 21.3084 10 18 10ZM18 18.71C16.3355 18.71 14.9813 17.4021 14.9813 15.7946C14.9813 14.187 16.3355 12.8792 18 12.8792C19.6645 12.8792 21.0187 14.187 21.0187 15.7946C21.0187 17.4022 19.6645 18.71 18 18.71Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000008671);
export default __webpack_public_path__ + "static/media/Group 1000008671.044b387b1ef3e04687b833636b30e307.svg";
export { ForwardRef as ReactComponent };